import { useQuery } from "@tanstack/react-query";
import { auth } from "../../../components/Auth/Auth.jsx";

const GetLatestShopDetails = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("No authenticated user found");

    const token = await user.getIdToken();

    const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/v2/shop/latest`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    if (!response.ok) {
        if (response.status === 401) {
            throw new Error("Unauthorized: Please log in again.");
        }
        throw new Error(`Network response was not ok (${response.status})`);
    }

    return response.json();
};

export const useLatestShopsData = () => {
    const { data, isPending, error } = useQuery({
        queryKey: ["LatestShopUpdated"],
        queryFn: GetLatestShopDetails,
    });

    return { data, isPending, error };
};
